export class ALCCampaignBaseLine {
  systemInputValue: number;
  kpiValue: number;

  constructor(init: Partial<ALCCampaignBaseLine>) {
    Object.assign(this, init);
  }
}
